import { combineEpics } from 'redux-observable';
import loader from './loader';

export const loaderEpic = combineEpics(loader);
